import React, { useContext, useState } from "react";
import { Button, Input, notification, Form } from "antd";
import GlobalContext from "../utils/GlobalContext";
import "moment-timezone";
import axios from "axios";
import MessageDialog from "../components/MessageDialog";

const Settings = () => {
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const globals = useContext(GlobalContext);
  const userEmail = globals.userEmail;
  const typeUser = globals.type;
  const handleOkErrorDialog = () => {
    setErrorDialogVisible(false);
  };

  const showErrorDialog = () => {
    setErrorDialogVisible(true);
  };

  const handleChangedPassword = async (values) => {
    if (values.password !== values.repassword) {
      setErrorMessage("Password and Re-Password must be the same");
      showErrorDialog()
      return;
    }
    try{
      const res = await axios.put(`${globals.SERVICE_API_AUTH}/v1/cambio-password`,
        { 
          email: userEmail, 
          password: values.currentPassword,
          newPassword: values.password
        },
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      const result = res.data;
      if (result.status === 0) {
        
        form.resetFields();
        notification.success({
          message: "Contraseña actualizada exitosamente!",
          placement: "bottomRight",
          duration: 2,
        });
      } else {
        setErrorMessage(result?.msg);
        showErrorDialog()
        return;
      }
    }
    catch(err) {
      console.log(err.response.data);
      if (err?.response?.data?.msg === undefined) {
        setErrorMessage("Change password failed");
      }
      else {
        if (err?.response?.data?.msg === "User or password incorrect") {
          setErrorMessage("Current password is incorrect");
        }else{
          setErrorMessage(err?.response?.data?.msg);
        }
      }
      showErrorDialog()
      return;
    }

  };

  const [form] = Form.useForm();

  const TitleBar = () => (
    <div
      style={{ display: "flex", alignItems: "center", marginBottom: "0px" }}
    >
      <h2 style={{ marginRight: "16px" }}>Configuración de cuenta</h2>
      <div style={{ flexGrow: 1, borderBottom: "1px solid #ccc" }} />
    </div>
  );

  return (
    <div style={{ padding: "24px" }}>
      <TitleBar />
      <div>
        <h3 style={{ marginBottom: "16px" }}>Información de usuario</h3>
        <div style={{ marginBottom: "16px" }}>
          <b>Correo:</b> {userEmail}
        </div>
        <div style={{ marginBottom: "16px" }}>
          <b>Tipo:</b> {typeUser.toLowerCase()}
        </div>
        {(typeUser === "LOCAL" || typeUser === "local") && (
        <div>
        <h3 style={{ marginBottom: "16px" }}>Cambiar contraseña</h3>
        <Form form={form} onFinish={handleChangedPassword}>
          <Form.Item
            name="currentPassword"
            rules={[
              { required: true, message: "Por favor ingrese su contraseña actual" },
            ]}
          >
            <Input.Password placeholder="Contraseña actual" style={{ width: "250px" }}/>
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              { required: true, message: "Por favor ingresa nueva contraseña" },
              { min: 6, message: "La contraseña debe tener al menos 6 caracteres" },
            ]}
          >
            <Input.Password placeholder="Nueva contraseña" style={{ width: "250px" }}/>
          </Form.Item>
          <Form.Item
            name="repassword"
            dependencies={["password"]}
            rules={[
              { required: true, message: "Por favor repita la nueva contraseña" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Las contraseñas no coinciden")
                  );
                },
              }),
            ]}
          >
            <Input.Password placeholder="Repetir nueva contraseña" style={{ width: "250px" }}/>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Cambiar contraseña
            </Button>
          </Form.Item>
        </Form>
        </div>
        )}     
      </div>
      <MessageDialog
        visible={errorDialogVisible}
        title="Cambio de contraseña fallido"
        message= {`${errorMessage}, por favor intenta de nuevo.`}
        onOk={handleOkErrorDialog}
        onCancel={handleOkErrorDialog}
        confirm={false}
      />
    </div>
  );
};

export default Settings;
